import {
  titleUI,
  ssnUI,
  ssnSchema,
} from 'platform/forms-system/src/js/web-component-patterns';
import { validations } from '../../validations';
import content from '../../../utils/content.json';

/** @type {PageSchema} */
export default {
  uiSchema: {
    ...titleUI(content['child-id-title']),
    childSocialSecurityNumber: {
      ...ssnUI(),
      'ui:validations': [validations.isSsnDuplicated],
    },
  },
  schema: {
    type: 'object',
    required: ['childSocialSecurityNumber'],
    properties: {
      childSocialSecurityNumber: ssnSchema,
    },
  },
};
